import React from 'react';

import { cx } from '@travel/utils';

import Media from 'components/Media';
import ReviewLink from 'pages/ProviderListPage/components/ReviewLink';

import type { Media as MediaType } from 'ProviderInformation-Types';

import styles from './providerSummary.module.scss';

type Props = {
  className?: string;
  name: string;
  id: string;
  reviewScore: number;
  totalReviews: number;
  reviewLabel?: string;
  media?: MediaType;
  market: string;
};

function ProviderSummary(props: Props) {
  const {
    className,
    name = '',
    reviewScore = 0,
    totalReviews = 0,
    reviewLabel,
    media,
    market,
    ...rest
  } = props;

  return (
    <div
      {...rest}
      data-testid={`providerSummary-wrapper-${props.id}`}
      className={cx(className, styles.providerSummaryContainer)}
    >
      <div className={styles.imageContainer}>
        <Media media={media} className={styles.image} sizes="120px" />
      </div>
      <div className={styles.informationContainer}>
        <div className={styles.name}>{name}</div>
        <ReviewLink
          market={market}
          reviewScore={reviewScore}
          totalReviews={totalReviews}
          reviewLabel={reviewLabel}
        />
      </div>
    </div>
  );
}

export default ProviderSummary;
